__webpack_require__.p = "https://wcdn.sduck.net/";